import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: false,
})
export class DialogComponent implements OnInit {
  matDialogRef = inject<MatDialogRef<DialogComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);

  title: string;
  message: string;
  btnOkText: string;
  btnCancelText: string;

  constructor() {
    this.title = this.data.title;
    this.message = this.data.message;
    this.btnOkText = this.data.btnOkText || 'Si';
    this.btnCancelText = this.data.btnCancelText || 'No';
  }

  ngOnInit() {}
}
